import type { RouteObject } from 'react-router'
import type { WaitForAuthResolutionFn } from '@/features/iam'
import type { UserManagementFeature } from '@/features/user-management'
import { createUserDetailsViewLoader } from '@/features/user-management/user-management-route-loaders'

/**
 * Options for {@link createRoutes}.
 */
export interface CreateUserManagementRoutesOptions {
  userManagement: UserManagementFeature
  waitForAuthResolution: WaitForAuthResolutionFn
}

/**
 * Creates routes for the user management feature.
 */
export function createRoutes(
  options: CreateUserManagementRoutesOptions,
): RouteObject[] {
  return [
    {
      path: '/users',
      lazy: {
        Component: () =>
          import('@/features/user-management/UserManagement/UserManagementContainer').then(
            (r) => r.default,
          ),
      },
    },
    {
      path: '/users/:userPublicId/*',
      loader: createUserDetailsViewLoader(options),
      lazy: {
        Component: () =>
          import('@/features/user-management/UserDetails/UserDetailsContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
